import { Component } from '@angular/core';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-imprint-dialog',
  templateUrl: './imprint-dialog.component.html',
  styleUrls: ['./imprint-dialog.component.scss'],
  standalone: false,
})
export class ImprintDialogComponent {
  public versionNumber = environment.buildInfo.version;
  public buildInfo = environment.buildInfo.number + ' built on ' + environment.buildInfo.time;

  constructor() {}
}
